import { render, staticRenderFns } from "./BaseAllLayoutsMenu.vue?vue&type=template&id=36ae1f87&scoped=true"
import script from "./BaseAllLayoutsMenu.vue?vue&type=script&lang=js"
export * from "./BaseAllLayoutsMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseAllLayoutsMenu.vue?vue&type=style&index=0&id=36ae1f87&prod&lang=scss&scoped=true"
import style1 from "./BaseAllLayoutsMenu.vue?vue&type=style&index=1&id=36ae1f87&prod&scoped=true&lang=css"
import style2 from "./BaseAllLayoutsMenu.vue?vue&type=style&index=2&id=36ae1f87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae1f87",
  null
  
)

export default component.exports